import React from 'react';
import { useContent } from '../../contexts/ContentContext';
import { isSessionPast } from '../../utils/sessionDates';
import './CalendarSessionsAdmin.css';

const CalendarSessionsAdmin = () => {
  const { content, updateContent } = useContent();
  const formations = content?.formations?.formationsGrid?.formations || [];

  const removeSession = (formationIndex, sessionIndex) => {
    const updated = formations.map((formation, fi) => {
      if (fi !== formationIndex) return formation;
      return {
        ...formation,
        sessions: (formation.sessions || []).filter((_, si) => si !== sessionIndex),
      };
    });
    updateContent('formations.formationsGrid.formations', updated);
  };

  const rows = formations.flatMap((formation, formationIndex) =>
    (formation.sessions || []).map((session, sessionIndex) => ({
      formationIndex,
      sessionIndex,
      formationTitle: formation.title,
      session,
      past: isSessionPast(session.date),
    }))
  );

  return (
    <div className="calendar-sessions-admin">
      <div className="calendar-sessions-admin__intro">
        <h3>Sessions du calendrier public</h3>
        <p>
          Les dates affichées sur <strong>/formations#calendar</strong> viennent des sessions
          de chaque formation ci-dessous — pas de la section « Calendrier Global » (titre
          uniquement). Cliquez sur <strong>✕</strong> pour supprimer une date ; la modification
          est enregistrée automatiquement.
        </p>
      </div>

      {rows.length === 0 ? (
        <p className="calendar-sessions-admin__empty">Aucune session enregistrée.</p>
      ) : (
        <ul className="calendar-sessions-admin__list">
          {rows.map(({ formationIndex, sessionIndex, formationTitle, session, past }) => (
            <li
              key={`${formationIndex}-${sessionIndex}`}
              className={`calendar-sessions-admin__item${past ? ' calendar-sessions-admin__item--past' : ''}`}
            >
              <div>
                <strong>{formationTitle}</strong>
                <span className="calendar-sessions-admin__date">{session.date}</span>
                {session.location && <span className="calendar-sessions-admin__meta">{session.location}</span>}
                {past && <span className="calendar-sessions-admin__badge">Passée</span>}
              </div>
              <button
                type="button"
                className="calendar-sessions-admin__remove"
                onClick={() => {
                  if (window.confirm(`Supprimer la session « ${session.date} » ?`)) {
                    removeSession(formationIndex, sessionIndex);
                  }
                }}
                title="Supprimer cette session"
              >
                ✕
              </button>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default CalendarSessionsAdmin;
